<template>
  <div>
    <b-btn
      variant="none"
      class="btn-outline-primary btn-sm"
      style="padding:0.5rem;"
      @click="openModalTipoProposta"
    ><feather-icon
      icon="PlusIcon"
    /><span style="color: #6e6b7b;">&nbsp;Nova Proposta</span></b-btn>

    <b-modal
      ref="tipoProposta"
      title="Selecione o tipo de proposta"
      centered
      size="lg"
      dialog-class="modal-centralizada"
      body-class="modal-proposta-body"
    >
      <div>
        <b-row>
          <b-col>
            <b-form-radio-group
              v-model="tipoProposta"
              stacked
              class="radio-lista"
            >
              <b-form-radio value="semchecklist">
                Proposta para serviços eventuais
              </b-form-radio>

              <b-form-radio value="constituicao">
                Proposta honorários empresas em constituição
              </b-form-radio>

              <b-form-radio value="transferencia">
                Proposta honorários empresas em transferência
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
      </div>

      <template #modal-footer>
        <b-button
          block
          size="md"
          class="btn-criar"
          @click="criarProposta"
        >
          Criar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modalProposta"
      size="xl"
      no-close-on-backdrop
      :footer-class="'custom-footer-class'"
      :dialog-class="'alteracao-tamanho'"
      :modal-class="'center-modal'"
      body-class="modal-proposta-view"
      header-class="modal-proposta-header"
      @shown="mountModal"
      @hide="toProposta"
    >
      <template #modal-title>
        <div style="display: flex;align-items: center;">
          <h2 style="margin-right: 2rem;">
            {{ propostaChecklist ? 'Proposta Comercial' : 'Proposta Comercial' }}</h2>
          <div>
            <div
              v-for="tag in proposta.etiquetas"
              :key="tag.id"
              :style="`background-color:${tag.cor}`"
              class="lista-proposta-tag tag-label"
            >
              <span>{{ tag.descricao }}</span>
            </div>
          </div>
        </div>
      </template>
      <div class="proposta-modal">
        <div
          v-if="proposta.id && (proposta.statusProposta === 'negociacao' || proposta.statusProposta === 'aprovada' || proposta.statusProposta === 'rejeitado' || proposta.statusProposta === 'expirada')"
          class="aviso"
        >
          Proposta desabilitada para edição! Motivo: {{ motivo }}
        </div>
        <div style="display: flex; align-items: flex-start;">
          <div
            :class="['container-class']"
          >
            <div class="proposta-resumo mb-2">
              <b-row class="proposta-info">
                <b-col
                  cols="3"
                  class="proposta-info-item"
                >
                  <div class="proposta-info-label">
                    Número
                  </div>
                  <div class="proposta-info-value">
                    {{ proposta.numeroProposta }}
                  </div>
                </b-col>
                <b-col
                  cols="3"
                  class="proposta-info-item"
                >
                  <div class="proposta-info-label">
                    Data de Criação
                  </div>
                  <div class="proposta-info-value">
                    {{ proposta.dataCadastro }}
                  </div>
                </b-col>
                <b-col
                  cols="3"
                  class="proposta-info-item"
                >
                  <div class="proposta-info-label">
                    Data da Proposta
                  </div>
                  <div class="proposta-info-value">
                    {{ proposta.dataProposta }}
                  </div>
                </b-col>
                <b-col
                  cols="3"
                  class="proposta-info-item"
                >
                  <div class="proposta-info-label">
                    Data de Finalização
                  </div>
                  <div class="proposta-info-value">
                    {{ dataFinalizacao() }}
                  </div>
                </b-col>
              </b-row>
            </div>

            <validation-observer ref="validacao">
              <dados-envio
                ref="dadosEnvio"
                v-model="proposta"
                :tipo-proposta="tipoProposta"
                :empresa-inicial="empresaInicial"
                :pessoa-inicial="pessoaInicial"
                @habilitar-botao="habilitarBotao"
              />

              <div :class="[{'desabilitar-inputs': proposta.id && (proposta.statusProposta !== 'pendenteenvio' && proposta.statusProposta !== 'naoaprovada')}]">
                <div v-if="showCondicoesGerais">
                  <b-row class="mt-2">
                    <b-col>
                      <divisoria-descricao
                        :titulo="'Condições Gerais'"
                        :descricao="'Aqui você pode visualizar as condições de validade da proposta comercial.'"
                      />
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-form-group
                      label="Prazo de Validade"
                      class="col-3"
                    >
                      <validation-provider
                        #default="{ errors }"
                        rules="required"
                        name="Prazo de Validade"
                      >
                        <b-select
                          v-model="proposta.prazoValidadeProposta"
                        >
                          <option
                            v-for="$index in 365"
                            :key="$index"
                            :value="$index"
                          >{{ $index == 1 ? $index + ' dia' : $index + ' dias' }}</option>
                        </b-select>
                        <small
                          v-if="errors[0]"
                          class="text-danger"
                        >O campo Prazo de Validade é obrigatório</small>
                      </validation-provider>
                    </b-form-group>
                    <b-col cols="3">
                      <div class="div-email">
                        <div>
                          <legend style="font-size: 14px;">
                            Data de Validade</legend>
                        </div>
                        <div style="padding-left: 0.4rem">
                          <i
                            v-b-tooltip.hover
                            title="Atenção: A contagem do Prazo de Validade é iniciado com o envio da proposta comercial a pessoa"
                            style="font-size: 0.65rem;"
                            class="question-icon"
                          >
                            <font-awesome-icon
                              :icon="faQuestionCircle"
                            />
                          </i>
                        </div>
                      </div>
                      <data-input
                        v-model="proposta.dataValidadeProposta"
                        :disabled="true"
                      />
                    </b-col>
                    <b-form-group
                      label="Prazo do Próximo Contato"
                      class="col-3"
                    >
                      <validation-provider
                        #default="{ errors }"
                        rules="required"
                        name="Prazo do Próximo Contato"
                      >
                        <b-select
                          v-model="proposta.prazoProximoContatoAgenda"
                        >
                          <option
                            v-for="$index in 365"
                            :key="$index"
                            :value="$index"
                          >{{ $index == 1 ? $index + ' dia' : $index + ' dias' }}</option>
                        </b-select>
                        <small
                          v-if="errors[0]"
                          class="text-danger"
                        >O campo Prazo de Validade é obrigatório</small>
                      </validation-provider>
                    </b-form-group>
                    <b-col cols="3">
                      <b-form-group label="Data do Próximo Contato">
                        <data-input
                          v-model="proposta.dataProximoContatoAgenda"
                          :disabled="true"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12">
                      <div class="tag-observacoes">
                        <legend style="font-size: 1rem; width: auto;">
                          Observações para a Pessoa</legend>
                        <dropdown-tag
                          ref="tagObservacao"
                          :tags="tagObservacoesPessoas"
                          @enviar-pai="addObservacao"
                        />
                      </div>
                      <quill-editor
                        ref="quillText"
                        v-model="proposta.observacao"
                        :options="opcoesTextArea"
                        :disabled="quillDisabled"
                      />
                    </b-col>
                  </b-row>
                </div>
              </div>
            </validation-observer>
          </div>

          <div class="button-class">
            <botoes-acoes
              ref="botaoacao"
              :proposta="proposta"
              :sem-contratante="proposta.semContratante"
              @ir-para-proposta="toProposta"
              @limpar-dados="limpaProposta"
              @close-modal="closeModal"
              @atualizar-dados="refresh"
              @enviar-checklist="salvarPropostaChecklist($event)"
              @campo-obrigatorio="campoContratante"
            />
          </div>
        </div>
      </div>

      <template #modal-footer>
        <footer-cadastro
          :ref="'footerCadastro'"
          :tramites="proposta.tramites"
          :observacoes-internas="proposta.observacoesInternas"
          :proposta-id-atual="parseInt(internalPropostaId)"
          :proposta="proposta"
          @close-modal="closeModal"
          @salvar-proposta="salvarProposta($event)"
          @salvar-checklist="salvarPropostaChecklist($event)"
          @enviar-proposta="enviarProposta"
        />
      </template>
      <b-modal
        ref="modalObservacoes"
        title="Observações internas"
        hide-footer
      >
        <div
          v-for="observacao in proposta.observacoesInternas"
          :key="observacao"
        >
          <div
            v-if="observacao.observacaoInterna"
            style="padding-bottom: 1rem;margin-bottom: 1rem; border-bottom: 1px solid #b8c2cc;"
          >
            <b>Observação:</b> {{ observacao.comentario }}<br><b>Usuário:</b> {{ observacao.usuCadastro }}<br><b>Data:</b> {{ observacao.dataCadastro }}
          </div>
        </div>
      </b-modal>
    </b-modal>
    <pre-geracao-contrato-proposta
      v-if="false"
      ref="preGeracaoContrato"
      :proposta-atual="proposta"
      :status-proposta="proposta.statusProposta"
      @abrir-modal="$refs.botaoacao.abritAlterarStatusProposta()"
    />
    <aprovar-contrato-manual
      v-if="false"
      ref="aprovarContratoManual"
      :proposta-atual="proposta"
      :status-proposta="proposta.statusProposta"
      @abrir-modal="$refs.botaoacao.abritAlterarStatusProposta()"
    />
  </div>
</template>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
.modal-proposta-view {
  background: #f6f7f9;
  padding: 1rem 1rem 0.75rem;
}

.modal-proposta-header .modal-title {
  color: #2f2f2f;
  font-weight: 700;
}

.proposta-modal {
  color: #3b3b3b;
}

.container-class {
  width: 100%;
  flex: 1;
  background: var(--card-bg);
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 0.65rem;
  padding: 1rem 1rem 0.75rem;
}

.proposta-resumo {
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 0.65rem;
  padding: 0.75rem;
  background: rgba(0, 0, 0, 0.015);
}

.proposta-info-item {
  border-right: 1px solid rgba(0, 0, 0, 0.06);
}

.proposta-info-item:last-child {
  border-right: 0;
}

.proposta-info-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #5b5b5b;
}

.proposta-info-value {
  font-size: 1rem;
  font-weight: 700;
  color: #2f2f2f;
}

.button-class {
  padding-left: 1rem;
  padding-right: 0.5rem;
  position: -webkit-sticky;
  position: sticky;
  top: 16.1vh;
  z-index: 10;
  min-width: 64px;
}

.alteracao-tamanho {
  width: 1400px !important;
}

.center-modal {
  display: flex !important;
  justify-content: center !important;
}

.modal-proposta-view h2 {
  color: #2f2f2f;
  font-weight: 800;
}

.modal-proposta-view h4 {
  color: #2f2f2f;
  font-weight: 800;
  font-size: 1.35rem;
}

.modal-proposta-view fieldset.text-muted {
  color: #585858 !important;
  font-weight: 500;
  font-size: 0.95rem;
}

.modal-proposta-view .form-group > label,
.modal-proposta-view .col-form-label {
  color: #3b3b3b;
  font-weight: 700;
}

.modal-proposta-view .table-responsive {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0.65rem;
  overflow: hidden;
  background: var(--card-bg);
}

.modal-proposta-view .table {
  margin-bottom: 0;
}

.modal-proposta-view .table thead th {
  background: rgba(0, 0, 0, 0.04);
  color: #2f2f2f;
  font-weight: 800;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.modal-proposta-view .table td {
  color: #3b3b3b;
}

.modal-proposta-view .table tbody tr:hover {
  background: rgba(0, 0, 0, 0.03);
}

.desabilitar-inputs {
  pointer-events: none;
}

//Email CC
.question-icon {
  font-size: 0.65;
  align-self: center;
  display: block;
}

.tags {
  font-size: 12.6px;
}

.b-form-tags .b-form-tags-list .b-from-tags-field {
  margin-bottom: 0.25rem;
 }

.b-form-tags .b-form-tags-list .b-form-tag {
  margin-top: 0.1rem;
  margin-left: -0.5rem;
  margin-bottom: -0.1rem;
}

.div-email {
  display: flex;
}

.label-question {
  font-size: x-small;
  cursor: pointer;
}

// Observacao
.tag-observacoes {
  display: flex;
  align-items: flex-end;
}

.dropdown-tag {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.ql-editor {
  max-height: 80px;
  overflow: auto;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}

//Tabela total valores
.tabela-total {
  width: (100% - 75.5%);
  th {
    background-color: var(--table-bg) !important;
  }

  td {
    background-color: var(--card-bg) !important;
  }

  th,
  td {
    padding: 0.5rem 0.2rem;
  }

  .table-hover {
    tr {
      cursor: default !important;
    }
  }
}

.custom-footer-class {
  display: block !important;
}

.aviso {
  text-align: left;
  font-size: 15.5px;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 1rem;

  p{
    margin:0
  }
}

//Etiquetas
.lista-proposta-tag {
  border-radius: 4px;
  display: inline-block;
  margin-right: 0.7rem;
  margin-bottom: 0.2rem;
  overflow: auto;
  position: relative;
  font-size: 12px;

  &.tag-label {
    width: auto;
    min-width: 40px;
    color: white;
    font-weight: 500;
    padding: 0 8px;
  }
}
</style>

<script src="sweetalert2.all.min.js"></script>
<script>
/* eslint-disable-next-line prefer-destructuring */
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { quillEditor } from 'vue-quill-editor'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { getUserData, getUserInfo } from '@/auth/utils'
import {
  required,
} from '@validations'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'

import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import apiParametrizacao from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/services/api'
import apiParametrizacaoChecklist from '@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/services/api'
import apiPacoteServico from '@/app-modulo/comercial/pacote-servico/shared/services/api'
import apiCertificado from '@/app-modulo/comuns/certificado/shared/services/api'
import apiTemplateEmail from '@/app-modulo/comuns/templates-gerais/shared/components/services/api'
import { handlePropostaError, validatePropostaObrigatorios } from '@/app-modulo/comercial/cadastro-proposta/shared/utils/errorHandler'

export default {
  name: 'CadastroProposta',
  props: {
    propostaIdAtual: {
      type: [String, Number],
      default: null,
    },
    autoOpenModal: {
      type: Boolean,
      default: false,
    },
    dealId: {
      type: [String, Number],
      default: null,
    },
    empresaInicial: {
      type: Object,
      default: null,
    },
    pessoaInicial: {
      type: Object,
      default: null,
    },
  },
  components: {
    FontAwesomeIcon,
    quillEditor,
    ValidationObserver,
    ValidationProvider,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    DropdownTag: () => import('@/shared/components/dropdown-tag/DropdownTag.vue'),
    FooterCadastro: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/footer-modal-cadastro/FooterCadastro.vue'),
    BotoesAcoes: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/botoes-acoes/BotoesAcoes.vue'),
    DadosEnvio: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/dados-envio/DadosEnvio.vue'),
    PreGeracaoContratoProposta: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/pre-geracao-contrato-proposta/ContratoPropostaModal.vue'),
    AprovarContratoManual: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/aprovar-contrato-manual/AprovarContratoManual.vue'),
  },
  data() {
    return {
      required,
      faQuestionCircle,
      proposta: {
        osConstituicao: false,
        semContratante: false,
        contratantePessoaFisica: false,
        empresasPessoa: [],
        selecaoPreenchimento: null,
        porcentagem: false,
        prazoProximoContatoAgenda: null,
        prazoValidadeProposta: null,
        observacao: null,
        geraContrato: false,
        templateContrato: '',
        servicos: [],
        servicosAdicionais: [],
        propostaPacote: {},
        emEdicao: true,
        valorTotalPropostaAuditar: 0.00,
        valorTotalPropostaRCC: 0.00,
        tramites: [],
        observacoesInternas: [],
        etiquetas: [],
        templatePropostaId: null,
        tributacao: null,
        atividade: null,
        mostrarDados: true,
        filial: null,
        tipoEmpresa: null,
        itemChecklistPropostas: [],
        valorTotalChecklist: 0,
        propostasPacotes: [{
          acrescimoPacote: 0,
          descontoPacote: 0,
        }],
      },
      tagObservacoesPessoas: ['Pessoa', 'Prazo', 'Data de Validade', 'Data de Vencimento', 'Data da Proposta (Envio)'],
      opcoesTextArea: {
        modules: {
          toolbar: false,
        },
        placeholder: 'Inclua observações sobre as condições gerais e Prazo de Validade dessa proposta para a pessoa (Cliente final)',
      },
      quill: {},
      internalPropostaId: this.propostaIdAtual || null,
      tipoProposta: null,
      quillDisabled: false,
      propostaCopia: null,
    }
  },
  computed: {
    ...mapGetters('proposta', ['getCheckOsConstituicao']),
    propostaChecklist() {
      return this.tipoProposta === 'constituicao' || this.tipoProposta === 'transferencia'
    },
    showCondicoesGerais() {
      return ((this.tipoProposta === 'constituicao' || this.tipoProposta === 'transferencia') && this.proposta.geradoProposta) || this.tipoProposta === 'semchecklist'
    },
    motivo() {
      if (this.proposta.statusProposta === 'aprovada') {
        return 'proposta aprovada não pode ser alterada.'
      }
      if (this.proposta.statusProposta === 'rejeitado') {
        return 'proposta rejeitada não pode ser alterada.'
      }
      if (this.proposta.statusProposta === 'expirada') {
        return 'proposta expirada não pode ser alterada.'
      }
      return 'aguardando ação da pessoa'
    },
  },
  watch: {
    getCheckOsConstituicao(value, oldValue){
      if(value !== oldValue){
        this.proposta.osConstituicao = this.getCheckOsConstituicao
      }
    },
    propostaIdAtual(newVal) {
      this.internalPropostaId = newVal
    },
  },
  created(){
    this.proposta.osConstituicao = this.getCheckOsConstituicao
    if(this.dealId){
      this.$set(this.proposta, 'dealId', this.dealId)
    }
  },
  mounted() {
    const routeId = Number(this.$route && this.$route.params && this.$route.params.propostaId) || null
    if (routeId) this.internalPropostaId = routeId
    if (this.autoOpenModal !== false) {
      this.showModal()
    }
  },
  methods: {
    ...mapActions('listas', ['adicionarPendente', 'adicionarNegociacao', 'atualizarPropostaColuna', 'adicionarChecklist', 'mudarColunaStatus']),
    ...mapActions('proposta', ['setProposta','setCheckOsConstituicao']),
    refresh() {
      this.$router.go()
    },
    openModalTipoProposta() {
      this.$refs.tipoProposta.show()
    },
    criarProposta() {
      if (this.tipoProposta === 'semchecklist') {
        this.setCheckOsConstituicao(false)
        this.proposta.osConstituicao = this.getCheckOsConstituicao
        this.$refs.tipoProposta.hide()
        this.$refs.modalProposta.show()
      } else if (this.tipoProposta === 'constituicao' || this.tipoProposta === 'transferencia') {
        apiParametrizacaoChecklist.existeChecklistHonorario()
          .then(payload => {
            if (payload.data) {
              apiPacoteServico.existePacoteHonorario()
                .then(pay => {
                  if (pay.data) {
                    this.$refs.tipoProposta.hide()
                    this.$refs.modalProposta.show()
                  } else {
                    this.$swal({
                      title: 'Atenção!',
                      text: 'Para cadastrar propostas com checklist deve ser cadastrado os pacotes de honorários nível I,II e III. Verifique a informação!',
                      icon: 'warning',
                      confirmButtonText: 'Ok',
                      customClass: {
                        confirmButton: 'btn btn-primary',
                      },
                    })
                  }
                })
            } else {
              this.$swal({
                title: 'Atenção!',
                text: 'Para enviar Proposta Comercial com Checklist no mínimo deve ter uma parametrização de checklist cadastrada. Verifique a informação!',
                icon: 'warning',
                confirmButtonText: 'Ok',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
              })
            }
          })
      }
    },
    showModal() {
      if (this.internalPropostaId > 0) {
        this.$refs.modalProposta.show()
      }
    },
    load() {
      api.getProposta(this.internalPropostaId)
        .then(payload => {
          this.setProposta(payload.data)
          this.setCheckOsConstituicao(payload.data.osConstituicao)
          this.proposta = payload.data
          this.tipoProposta = this.proposta.tipoProposta
          this.proposta.emEdicao = false
          this.quillDisabled = false
          if(this.proposta.observacoesInternas){
            this.abrirModalObservacao(this.proposta.observacoesInternas)
          }
        })
    },
    abrirModalObservacao(observacoes) {
      let showModalObservacao = false
      observacoes.forEach(observacao => {
        if(observacao.observacaoInterna){
          showModalObservacao = true
        }
      })
      if(showModalObservacao){
        this.$refs.modalObservacoes.show()
      }
    },
    addObservacao(value) {
      this.quill.insertText(this.quill.getSelection(true), value, 'bold', true)
      this.quill.setSelection(this.quill.getSelection(true).index + value.length)
      this.quill.insertText(this.quill.getSelection(true), ' ', 'bold', false)
    },
    mountModal() {
      this.quillDisabled = true
      if (this.$refs.quillText) {
        this.quill = this.$refs.quillText.quill
      }
      this.$set(this.proposta, 'tipoProposta', this.tipoProposta)
      this.$set(this.proposta, 'geradoProposta', false)
      if (!this.internalPropostaId) {
        setTimeout(() => {
           const userInfo = getUserInfo()
           if(userInfo) {
             this.$set(this.proposta, 'responsavel', userInfo.id)
             this.$set(this.proposta, 'idResponsavel', userInfo.id)
             this.$set(this.proposta, 'nomeResponsavel', userInfo.nome)
             this.$set(this.proposta, 'emailResponsavel', userInfo.email)
           }
        }, 100)

        apiParametrizacao.getParametrizacaoResumida()
          .then(payload => {
            this.proposta.prazoValidadeProposta = payload.data.vencimentoProposta
            this.proposta.prazoProximoContatoAgenda = payload.data.prazoProximaAgenda
            if (payload.data.observacao) {
              this.proposta.observacao = payload.data.observacao
            }
            this.quillDisabled = false
          })
      } else if (this.internalPropostaId > 0) {
        this.load()
      }
    },
    closeModal() {
      this.$refs.modalProposta.hide()
    },
    toProposta() {
      this.limpaProposta()
      this.tipoProposta = 'semchecklist'
      if (this.internalPropostaId > 0) {
        if (this.$route.path.indexOf('proposta/') > 0) {
          this.$router.push({ name: 'painel-proposta' })
        }
      }
      this.$emit('fechar-proposta')
      this.internalPropostaId = null
    },
    limpaProposta() {
      this.proposta = {
        prazoProximoContatoAgenda: null,
        prazoValidadeProposta: null,
        observacao: null,
        geraContrato: false,
        templateContrato: '',
        servicos: [],
        servicosAdicionais: [],
        propostaPacote: {},
        emEdicao: true,
        valorTotalPropostaAuditar: 0,
        valorTotalPropostaRCC: 0,
        tramites: [],
        observacoesInternas: [],
        etiquetas: [],
        templatePropostaId: null,
        tributacao: null,
        atividade: null,
        mostrarDados: true,
        filial: null,
        tipoEmpresa: null,
        itemChecklistPropostas: [],
        valorTotalChecklist: 0,
      }
      this.$refs.dadosEnvio.limparDadosEnvio()
    },
    salvarPropostaChecklist(footer) {
      if(this.proposta.tipoProposta === 'semchecklist'){
        this.proposta.osConstituicao = this.getCheckOsConstituicao
      }
      this.$refs.validacao.validate()
        .then(success => {
          if (this.proposta.checklistCNPJ && this.proposta.checklistCNPJ.length > 0) {
            this.proposta.itemChecklistPropostas.push(...this.proposta.checklistCNPJ)
          }
        this.propostaCopia = JSON.parse(JSON.stringify(this.proposta))

          if (
            Array.isArray(this.propostaCopia.empresasPessoa)
          ) {
            this.propostaCopia.empresasPessoa = this.propostaCopia.empresasPessoa.map(e =>
              typeof e === 'string' ? JSON.parse(e) : e
            )
          }

          if (success) {
            if(footer.gerarProposta) {
              this.$refs.dadosEnvio.$refs.checklist.$refs.tabelaChecklist.$refs.validacaoChecklist.validate()
                .then(success => {
                  if (success) {
                    this.salvarPropostaChecklistValidado(footer)
                  } else {
                    this.proposta.itemChecklistPropostas = this.proposta.itemChecklistPropostas.filter(fil => fil.tipoRegra !== 'tags')
                  }
                })
            } else {
              this.salvarPropostaChecklistValidado(footer)
            }
          }
        })
    },
    async validarAntesDeEnviarProposta() {
      const okForm = await this.$refs.validacao.validate()
      if (!okForm) {
        this.$erro('Preencha os campos corretamente!')
        return false
      }

      const validation = validatePropostaObrigatorios(this.proposta)
      if (!validation.valid) {
        this.$erro(validation.message)
        return false
      }

      if (this.proposta.geraContrato === true) {
        const templateContrato = this.proposta.templateContrato
        const okContrato = typeof templateContrato === 'string' ? templateContrato.trim().length > 0 : !!templateContrato
        if (!okContrato) {
          this.$erro('Selecione um template de contrato antes de enviar a proposta')
          return false
        }
      }

      return true
    },
    salvarPropostaChecklistValidado(footer){
      if (this.internalPropostaId > 0) {
        if (!footer.enviarProposta) {
          this.atualizarPropostaCheckList(false, footer.gerarProposta)
        }
        if (footer.enviarProposta){
          this.validarAntesDeEnviarProposta()
            .then(ok => {
              if (!ok) {
                this.proposta.itemChecklistPropostas = this.proposta.itemChecklistPropostas.filter(fil => fil.tipoRegra !== 'tags')
                return
              }

              this.$isLoading(true)
              api.enviarProposta(this.propostaCopia, 'Checklist')
                .then(() => {
                  this.$sucesso('Checklist enviado!')
                  this.closeModal()
                })
                .catch(err => {
                  const errorInfo = handlePropostaError(err)
                  this.$erro(errorInfo.message)
                })
                .finally(() => {
                  this.$isLoading(false)
                  this.proposta.itemChecklistPropostas = this.proposta.itemChecklistPropostas.filter(fil => fil.tipoRegra !== 'tags')
                })
            })
        }
      } else {
        this.$isLoading(true)
        api.adicionarPropostaChecklist(footer.gerarProposta, this.proposta)
          .then(payload => {
            this.adicionarArquivosChecklist(payload)
            this.internalPropostaId = payload.data.id

            if (footer.gerarProposta) {
              this.$router.push({ name: 'cadastro-proposta', params: { propostaId: this.internalPropostaId } })
              this.adicionarPendente(payload.data)
            } else if (footer.enviarProposta) {
              this.enviarPropostaChecklist()
            } else {
              this.adicionarChecklist(payload.data)
              this.closeModal()
            }
          })
          .catch(err => {
            const errorInfo = handlePropostaError(err)
            this.$erro(errorInfo.message)
          })
          .finally(() => {
            this.$isLoading(false)
            this.proposta.itemChecklistPropostas = this.proposta.itemChecklistPropostas.filter(fil => fil.tipoRegra !== 'tags')
          })
      }
    },
    enviarPropostaChecklist() {
      this.validarAntesDeEnviarProposta()
        .then(ok => {
          if (!ok) return

          this.proposta.id = this.internalPropostaId
          this.propostaCopia.id = this.internalPropostaId
          this.$isLoading(true)
          api.enviarProposta(this.propostaCopia,'Checklist')
            .then(payload => {
              this.adicionarChecklist(payload.data)
              this.$sucesso('Checklist enviado!')
              this.closeModal()
            })
            .catch(err => {
              const errorInfo = handlePropostaError(err)
              this.$erro(errorInfo.message)
            })
            .finally(() => {
              this.$isLoading(false)
            })
        })
    },
    adicionarArquivosChecklist(payload) {
      if (payload.data.itemChecklistPropostas) {
        payload.data.itemChecklistPropostas.forEach(item => {
          const file = this.proposta.itemChecklistPropostas.filter(fil => item.nomeArquivo === fil.nomeArquivo)
          const formData = this.getFormDataBody(file, item)
          this.addAnexoCheckList(formData)
        })
      }
    },
    addAnexoCheckList(formData) {
      let uploadCancelado = false
      const axios = require('axios')
      const swal = require('sweetalert2')
      swal.fire({
        title: 'Aguarde, estamos enviando o arquivo anexado para o servidor!',
        willOpen() {
          swal.showLoading()
        },
        didClose() {
          if (swal.DismissReason.cancel) {
            uploadCancelado = true
            api.abortarUpload()
          } else {
            swal.hideLoading()
          }
        },
        showConfirmButton: false,
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          actions: 'vertical-buttons',
          title: 'modal-upload-title',
          cancelButton: 'top-margin',
        },
      })

      api.addAnexoItemCheckList(formData, axios.CancelToken, false)
        .then(() => {
          swal.close()
          this.$confirmar('Sucesso', 'Anexo salvo com sucesso!', 'success', '')
        })
        .catch(err => {
          swal.close()
          if (!uploadCancelado) {
            if (!err || typeof err.response === 'undefined') {
              this.$confirmar('Erro', 'Tamanho do arquivo excedeu o limite de 512mb', 'error', '')
            } else {
              this.$handleError(err)
            }
          }
        })
    },
    salvarProposta(continuarEditando) {
      if(this.proposta.tipoProposta === 'semchecklist'){
        this.proposta.osConstituicao = this.getCheckOsConstituicao
      }

      this.$refs.validacao.validate()
        .then(async success => {
          if (success && this.$refs.dadosEnvio && this.$refs.dadosEnvio.validarTemplateProposta) {
            const okTemplate = await this.$refs.dadosEnvio.validarTemplateProposta()
            if (!okTemplate) {
              return
            }
          }

          if (success) {
            if (this.proposta.tipoProposta === 'transferencia' || this.proposta.tipoProposta === 'constituicao') {
              if (this.proposta.propostasPacotes[0].valorPacote !== this.proposta.valorTotalChecklist && this.proposta.propostasPacotes[0].nivel === 'Nível I - Básico'
                  && !this.proposta.alterouDadosChecklist) {
                    if(this.proposta.etiquetas.find(fin => fin.descricao === "Não aprovada") === undefined){
                      this.$confirmar('Deseja realmente alterar o checklist?',
                        'Essa alteração impacta diretamente no valor da proposta, ao confirmar, será atualizado o valor do (s) pacote de honorários. Tem certeza que deseja continuar?',
                        'question', 'danger')
                        .then(result => {
                          if (result.value) {
                            this.registrarProposta(false)
                          }
                      })
                    } else {
                      this.registrarProposta(false)
                    }
              } else {
                this.registrarProposta(continuarEditando)
              }
            } else {
              this.registrarProposta(continuarEditando)
            }
          } else {
            this.$erro('Preencha os campos corretamente!')
          }
        })
    },
    registrarProposta(continuarEditando) {
      if (this.$refs.dadosEnvio && this.$refs.dadosEnvio.$refs.empresaContratante) {
        const cnpjValido = this.$refs.dadosEnvio.$refs.empresaContratante.validateCnpjField()
        if (!cnpjValido) {
          return
        }
      }

      const validation = validatePropostaObrigatorios(this.proposta)

      if (!validation.valid) {
        this.$erro(validation.message)
        return
      }

      if (this.proposta.checklistCNPJ && this.proposta.checklistCNPJ.length > 0) {
        this.proposta.itemChecklistPropostas.push(...this.proposta.checklistCNPJ)
      }
      this.propostaCopia = JSON.parse(JSON.stringify(this.proposta))
      if (
          Array.isArray(this.propostaCopia.empresasPessoa)
        ) {
          this.propostaCopia.empresasPessoa = this.propostaCopia.empresasPessoa.map(e =>
            typeof e === 'string' ? JSON.parse(e) : e
          )
        }
      if (this.proposta.tipoProposta === 'transferencia' || this.proposta.tipoProposta === 'constituicao') {
        this.proposta.itemChecklistPropostas = this.proposta.itemChecklistPropostas.filter(fil => fil.tipoRegra !== 'tags')
      }
      this.removeCaracteresPorcentagem(this.propostaCopia)
      if (this.internalPropostaId > 0) {
        this.atualizarProposta(continuarEditando)
      } else {
        this.adicionarProposta(continuarEditando)
      }
    },
    adicionarProposta(continuarEditando) {
      this.$isLoading(true)
      let loadingDisabled = false
      const stopLoading = () => {
        if (!loadingDisabled) {
          loadingDisabled = true
          this.$isLoading(false)
        }
      }

      api.adicionarProposta(this.propostaCopia)
        .then(payload => {
            this.internalPropostaId = payload.data.id
          this.$sucesso('Proposta cadastrada com sucesso')

              return apiTemplateEmail.validaTemplates([this.internalPropostaId])
            .then(resp => {
              const templateValidationMessage = resp && resp.data
              const normalizedMessage = typeof templateValidationMessage === 'string'
                ? templateValidationMessage.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
                : ''
              const hasEventualTemplateWarning = normalizedMessage.includes('servicos enventuais')
                || normalizedMessage.includes('servicos eventuais')

              if (hasEventualTemplateWarning && this.propostaCopia.tipoProposta === 'semchecklist') {
                stopLoading()
                return this.$atencao('Atenção', templateValidationMessage, 'Ciente').then(() => {
                  this.adicionarPendente(payload.data)
                  this.closeModal()
                })
              }

              if (!continuarEditando) {
                stopLoading()
                return this.$confirmar('', 'Deseja enviar a Proposta Comercial agora?', 'question', 'danger')
                  .then(async result => {
                    if (result.value) {
                      const okEnviar = await this.validarAntesDeEnviarProposta()
                      if (!okEnviar) {
                        stopLoading()
                        return Promise.resolve()
                      }

                      loadingDisabled = false
                      this.$isLoading(true)
                      this.proposta.id = this.internalPropostaId
                      this.propostaCopia.id = this.internalPropostaId

                      return api.enviarProposta(this.propostaCopia, 'envioProposta')
                        .then(payloadCartao => {
                          this.adicionarNegociacao(payloadCartao.data)
                          this.$sucesso('Proposta enviada!')
                          this.closeModal()
                        })
                        .catch(err => {
                          const errorInfo = handlePropostaError(err)

                          const msgErro = 'Está proposta se encontra inválida. Entre em contato com a Tânia para informar exatamente o passo a passo que ocasionou esse problema.'
                          if (errorInfo.originalMessage === msgErro) {
                            this.$atencaoHtml('', `<strong>ERRO! <br> ${errorInfo.originalMessage}</strong>`, 'Ciente')
                          } else {
                            this.$erro(errorInfo.message)
                          }
                        })
                        .finally(() => {
                          stopLoading()
                        })
                    } else {
                      this.adicionarPendente(payload.data)
                      this.closeModal()
                      return Promise.resolve()
                    }
                  })
              } else {
                stopLoading()
                this.adicionarPendente(payload.data)
                this.$router.push({ name: 'cadastro-proposta', params: { propostaId: this.internalPropostaId } })
                return Promise.resolve()
              }
            })
            .catch(err => {
              const errorInfo = err?.response ? handlePropostaError(err) : {
                message: 'Não foi possível validar os templates de email',
                originalMessage: err?.message,
              }
              this.$erro(errorInfo.message)
            })
        })
        .catch(err => {
          const errorInfo = handlePropostaError(err)
          this.$erro(errorInfo.message)
        })
        .finally(() => {
          if (!loadingDisabled) {
            this.$isLoading(false)
          }
        })
    },
    atualizarProposta(continuarEditando) {
      this.$isLoading(true)
      api.atualizarProposta(this.internalPropostaId, this.propostaCopia)
        .then(payload => {
          const cartao = { propostaCartao: payload.data, colunaDe: payload.data.statusProposta }
          this.atualizarPropostaColuna(cartao)
          this.internalPropostaId = payload.data.id

          if (!continuarEditando) {
            this.closeModal()
          } else {
            if (this.$route.path.indexOf('/proposta') > 0) {
              if (payload.data.validade) {
                moment.locale('pt-BR')
                this.proposta.dataValidadeProposta = moment(payload.data.validade).format('DD/MM/YYYY')
              }
            } else {
              this.$router.push({ name: 'cadastro-proposta', params: { propostaId: this.internalPropostaId } })
            }
          }

          this.$sucesso('Proposta atualizada com sucesso')
        })
        .catch(err => {
          const errorInfo = handlePropostaError(err)

          const msgErro = 'Está proposta se encontra inválida. Entre em contato com a Tânia para informar exatamente o passo a passo que ocasionou esse problema.'
          if (errorInfo.originalMessage === msgErro) {
            this.$atencaoHtml('', `<strong>ERRO! <br> ${errorInfo.originalMessage}</strong>`, 'Ciente')
          } else {
            this.$erro(errorInfo.message)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    atualizarPropostaCheckList(continuarEditando, gerarProposta) {
      this.$isLoading(true)
      api.atualizarPropostaCheckList(this.propostaCopia, gerarProposta)
        .then(payload => {
          if (this.propostaCopia.responsavelAResponder === 'gerenteresponsavel' && payload.data.itemChecklistPropostas){
            payload.data.itemChecklistPropostas.forEach(item => {
              if (item.nomeArquivo !== '') {
                const file = this.proposta.itemChecklistPropostas.filter(fil => item.nomeArquivo === fil.nomeArquivo)
                const formData = this.getFormDataBody(file, item)
                this.addAnexoCheckList(formData)
                enviadoArquivo = true
              }
            })
          }
          const cartao = { propostaCartao: payload.data, colunaPara: payload.data.statusProposta, colunaDe: payload.data.statusPropostaAntiga }
          this.atualizarPropostaColuna(cartao)
          this.mudarColunaStatus(cartao)
          this.internalPropostaId = payload.data.id

          if (!continuarEditando && !gerarProposta) {
            this.closeModal()
          } else {
            if (this.$route.path.indexOf('/proposta') > 0) {
              this.$router.push({ name: 'painel-proposta' })
                .then(() => {
                  if (this.dealId) {
                    this.$router.push({ name: 'editar-proposta-da-oportunidade', params: { oportunidadeId: this.dealId, id: this.internalPropostaId }})
                  }
                })
            } else {
              this.$router.push({ name: 'cadastro-proposta', params: { propostaId: this.internalPropostaId } })
            }
          }

          this.$sucesso('Checklist atualizado com sucesso')
        })
        .catch(err => {
          const errorInfo = handlePropostaError(err)
          this.$erro(errorInfo.message)
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    removeCaracteresPorcentagem(proposta) {
      if (this.proposta.porcentagem) {
        for (let i = 0; i < proposta.propostasPacotes.length; i += 1) {
          const element = proposta.propostasPacotes[i]
          if (element.acrescimoPacote) {
            this.propostaCopia.propostasPacotes[i].acrescimoPacote = parseFloat(element.acrescimoPacote.replace('%', ''), 10)
          }
          if (element.descontoPacote) {
            this.propostaCopia.propostasPacotes[i].descontoPacote = parseFloat(element.descontoPacote.replace('%', ''), 10)
          }
        }
      }

      if (proposta.servicos && proposta.servicos.length > 0 && this.proposta.porcentagem && proposta.servicos.some(som => som.servico)) {
        for (let index = 0; index < proposta.servicos.length; index += 1) {
          const acrescimo = proposta.servicos[index].acrescimo
          const desconto = proposta.servicos[index].desconto
          if (acrescimo) {
            this.propostaCopia.servicos[index].acrescimo = parseFloat(acrescimo.replace('%', ''), 10)
          }
          if (desconto) {
            this.propostaCopia.servicos[index].desconto = parseFloat(desconto.replace('%', ''), 10)
          }
        }
      }

      if (proposta.servicosAdicionais && proposta.servicosAdicionais.length > 0 && this.proposta.porcentagem && proposta.servicosAdicionais.some(som => som.servico)) {
        for (let index = 0; index < proposta.servicosAdicionais.length; index += 1) {
          const acrescimo = proposta.servicosAdicionais[index].acrescimo
          const desconto = proposta.servicosAdicionais[index].desconto

          if (acrescimo) {
            this.propostaCopia.servicosAdicionais[index].acrescimo = parseFloat(acrescimo.replace('%', ''), 10)
          }
          if (desconto) {
            this.propostaCopia.servicosAdicionais[index].desconto = parseFloat(desconto.replace('%', ''), 10)
          }
        }
      }
    },
    enviarProposta() {
      if (this.$refs.botaoacao && this.$refs.botaoacao.enviarProposta) {
        this.$refs.botaoacao.enviarProposta()
      }
    },
    habilitarBotao(value) {
      this.$refs.footerCadastro.habilitarBotao(value)
    },
    getFormDataBody(fileItem, body) {
      const formData = new window.FormData()
      const file = fileItem[0].arquivoAnexo
      if (file) {
        formData.append('file', file.file, file.filename || file.name)
      }
      formData.append('body', JSON.stringify(body))

      return formData
    },
    campoContratante() {
      this.$refs.dadosEnvio.setEmpresaContratanteObrigatorio()
    },
    dataFinalizacao(){
      if(this.proposta.statusProposta !== 'aprovada' && this.proposta.statusProposta !== 'rejeitado' && this.proposta.statusProposta !== 'expirada' && this.proposta.statusProposta !== 'aguardandoassinatura' && this.proposta.statusProposta !== 'finalizada')
      {
        return 'aprovação :'
      }
      else if(this.proposta.statusProposta === 'expirada')
      {
        return 'expiração : '  + this.proposta.dataFinalizacao
      }
      else if(this.proposta.statusProposta === 'rejeitado')
      {
        return 'rejeição : ' + this.proposta.dataFinalizacao
      }
      else
      {
       return 'aprovação : ' + this.proposta.dataFinalizacao
      }

    }
  },
}
</script>
